import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './LoadingBar.module.css';

function LoadingBar() {
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setLoading(true);
        setProgress(20);

        const t1 = setTimeout(() => setProgress(60), 100);
        const t2 = setTimeout(() => setProgress(90), 300);
        const t3 = setTimeout(() => {
            setProgress(100);
            const t4 = setTimeout(() => {
                setLoading(false);
                setProgress(0);
            }, 200);
            return () => clearTimeout(t4);
        }, 500);

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
        };
    }, [location]);

    if (!loading && progress === 0) return null;

    return (
        <div className={styles.bar} style={{ width: `${progress}%`, opacity: progress === 100 ? 0 : 1 }} />
    );
}

export default LoadingBar;